"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var root_reducer_1 = require("./root.reducer");

exports.rootReducer = root_reducer_1.rootReducer;